module.exports = __webpack_public_path__ + "static/media/Rosalind R.63a3acd9.png";